import { RouteRecordRaw } from 'vue-router';
import { ViewModelPage } from '@/pages/registry-management';

export const routeName = 'GestaoRegistrosModeloVisualizar';

export const route: RouteRecordRaw = {
  path: 'gestao-registros/modelos/:id',
  name: routeName,
  component: ViewModelPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Visualizar Modelo',
    dynamicBreadcrumb: true,
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
};
